import { Outlet } from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";
import { AuthProvider } from "../lib/contexts/auth-context";

export default function RootRoute() {
	return (
		<div id="root-route-component">
			<AuthProvider>
				<Outlet />
				<TanStackRouterDevtools position="top-right" />
			</AuthProvider>
		</div>
	);
}
